// --------------------------------------------------------------------------
// mobileNav.js
// --------------------------------------------------------------------------
// Uses responsive DOM to build the mobile nav which then gets toggled by button
// --------------------------------------------------------------------------

EC.mobileNav = function () {

    'use strict';

    let $navBar;

    function init () {
        $('.js-mobile-nav').responsiveDom({
            appendTo: '#js-mobile-nav',
            mediaQuery: '(max-width: 869px)',
        });
        $navBar = $('.l-mobile-nav');
        $('.js-mobile-nav-children').on('click', showChildren);
        $('.js-mobile-nav-back').on('click', showParents);
    }

    function showChildren () {
        $('.b-nav-bar__dropdown--is-visible').removeClass('b-nav-bar__dropdown--is-visible');
        $(this.getAttribute('href')).addClass('b-nav-bar__dropdown--is-visible');
        $navBar.addClass('l-mobile-nav--show-children');
        return false;
    }

    function showParents () {
        $navBar.removeClass('l-mobile-nav--show-children');
        return false;
    }

    return {
        init: init
    };

}();